<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">标题设置</div>
    <el-input v-model="shareTitle" :maxlength="20" class="edit-shelfname-input"></el-input>
  </div>
</template>

<script>
export default {
  name: 'shelfLibSetTitle',
  props: {
    type: Object
  },
  data() {
    return {
      myType: this.type
    }
  },
  computed: {
    shareTitle: {
      get: function() {
        let data1 = this.$store.state.config.bookLibObj.shareTitle
        let data2 = this.$store.state.config.bookShelfObj.shareTitle
        if (this.myType.getType == 'Lib') {
          return data1
        } else {
          return data2
        }
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.myType.setType + 'TITLE_MESSAGE', newValue)
      }
    }
  }
}
</script>

<style></style>
